import React, { useState } from "react";
import { MdOutlineDarkMode } from "react-icons/md";
import { MdOutlineLightMode } from "react-icons/md"

function DarkThemeToggleComponent() {
  //eslint-disable-next-line
  const [darkMode, setDarkMode] = useState(
    localStorage.getItem("darkMode") == "true"
  );

  const toggleDarkMode = () => {
    const darkTheme = localStorage.getItem("darkMode");
    //eslint-disable-next-line
    if (darkTheme == "true") {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("darkMode", false);
      setDarkMode(false);
      document.querySelector('meta[name="theme-color"]').setAttribute("content", "#fff");
    } else {
      document.documentElement.classList.add("dark");
      localStorage.setItem("darkMode", true);
      setDarkMode(true);
      document.querySelector('meta[name="theme-color"]').setAttribute("content", "#0B1120");
    }
  };

  return (
    <>
      {
        // darkMode ? <img src={Light} alt="light" className="w-7 cursor-pointer" onClick={toggleDarkMode}></img> : <img src={Dark} alt="dark" className="w-7" onClick={toggleDarkMode}></img>
        darkMode ? (
          // <img src={Light} alt="light" className="w-7" onClick={toggleDarkMode}></img>
          <div onClick={toggleDarkMode}>
            <MdOutlineLightMode size={24} className="text-gray-400" />
          </div>
        ) : (
          // <img src={Dark} alt="dark" className="w-7" onClick={toggleDarkMode}></img>
          <div onClick={toggleDarkMode}>
            <MdOutlineDarkMode size={24} className="text-gray-400"/>
          </div>
        )
      }
    </>
  );
}

export default DarkThemeToggleComponent;
